<template>
  <div>
    <Follow :show.sync="showFllow" v-if="showFllow"></Follow>
    <Bind-Phone v-if="showPhone"></Bind-Phone>
  </div>
</template>

<script>
import { checkUserInfo } from '../../api/user'
// import { APPID } from '../../config/index'
import store from '../../store'
import { getQueryString } from '../../util/index'
import { getData } from '../../api/login'
export default {
  data() {
    return {
      showFllow: false,
      showPhone: false
    }
  },
  beforeRouteEnter(to, from, next) {
    // ...
    // console.log('from', JSON.stringify(from))
    // console.log('to', JSON.stringify(to))
    next(async vm => {
      // 本地储存code解决地址栏一直携带code导致的刷新和分享携带code问题
      // localStorage.setItem('code', '091pwnFa1mF8lE0AyjJa17C0zI3pwnFl')
      const urlCode = getQueryString('code')
      const code = localStorage.getItem('code')
      if (urlCode) {
        localStorage.setItem('code', urlCode)
        window.location.replace(process.env.VUE_APP_BASE_URL + '/sudiao/#/login')
      } else if (code) {
        try {
          localStorage.removeItem('code')
          store.commit('setGlobalLoading', true)
          let res = await getData({ code })
          store.commit('setGlobalLoading', false)
          if (!res.error) {
            // 无异常直接登录
            store.commit('setUserInfo', res.data)
            let userInfo = res.data
            store.commit('setGlobalLoading', true)
            checkUserInfo({ openid: userInfo.user.openid }).then(res => {
              store.commit('setGlobalLoading', false)
              const { phone, subscribe, status } = res.data
              if (subscribe === 0) {
                // 未关注公众号
                vm.showFllow = true
                localStorage.setItem(
                  'sdInfo',
                  JSON.stringify({
                    ...userInfo,
                    isFllow: 0
                  })
                )
                return
              } else if (phone === 0) {
                // 未绑定手机号
                vm.showPhone = true
                localStorage.setItem(
                  'sdInfo',
                  JSON.stringify({
                    ...userInfo,
                    isEdit: 0
                  })
                )
                return
              } else if (status !== 1) {
                // 被拉黑
                localStorage.removeItem('sdInfo')
                vm.$dialog
                  .alert({
                    title: '提示',
                    message: '用户信息异常，无法进行答卷'
                  })
                  .then(() => {
                    window.location.replace(process.env.VUE_APP_BASE_URL + '/sudiao/#/error')
                  })
                return false
              } else {
                // 正常登录
                const path = localStorage.getItem('nextgo') || '#/question/index'
                localStorage.removeItem('nextgo')
                window.location.replace(process.env.VUE_APP_BASE_URL + '/sudiao/' + path)
                // vm.$router.push('/question/index')
                // vm.$router.replace('/question/index')
              }
            })
            // window.location.replace(process.env.VUE_APP_BASE_URL + '/sudiao/#/login')
          } else {
            // 访问getData出错
            localStorage.removeItem('sdInfo')
            vm.$dialog
              .alert({
                title: '提示',
                message: '系统异常'
              })
              .then(() => {
                window.location.replace(process.env.VUE_APP_BASE_URL + '/sudiao/#/error')
              })
            // 有异常信息，提示错误，无法进入系统
            return false
          }
        } catch (error) {
          store.commit('setGlobalLoading', false)
        }
      } else {
        const src = encodeURIComponent(process.env.VUE_APP_REDIRECT_URI)
        console.log(src, 'src')
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_APPID}&redirect_uri=${src}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`
        console.log(url, 'url')
        window.location.href = url
      }
    })
  },
  components: {
    Follow: () => import('../../components/Follow'),
    'Bind-Phone': () => import('../../components/BindPhone')
  },
  beforeRouteLeave(to, from, next) {
    this.showEdit = false
    this.showFllow = false
    next()
  }
}
</script>
